import { Injectable } from '@angular/core';
import { BaseDataService } from '@core/service/base-data.service';
import { AssignedProductsFiltersVm, AssignProductsRequest } from '../models/assign-products-request';
import { Observable } from 'rxjs';
import { Organization } from 'app/home/organizations/models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class ProductsRequestService {

  private apiResellerProduct = 'api/ResellerProductRequests'
  private apiResellerOrganization = 'api/Organizations/list'
  private apiProduct = 'api/Products'

  constructor(private baseDataService: BaseDataService) { }

  createAssignProducts(assignProduct:AssignProductsRequest) : Observable<any> {
    return this.baseDataService.makePostCall(`${this.apiResellerProduct}`,assignProduct)
  }

  getAssignProductList(): Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiResellerProduct}`)
  }

  getAllAssignProductsList(assignedProductsFilters?: AssignedProductsFiltersVm) : Observable<AssignedProductsFiltersVm> {
    return this.baseDataService.makePostCall(`${this.apiResellerProduct}/list`,assignedProductsFilters)
  }

  getOrganizationLookup() :Observable<Organization[]>{
    return this.baseDataService.makeGetCall(`${this.apiResellerOrganization}`)
  }

  getAssignProductById(id: string) : Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiResellerProduct}/${id}`)
  }

  editAssignedProduct(assignProduct?:AssignProductsRequest) : Observable<any>{
    return this.baseDataService.makePutCall(`${this.apiResellerProduct}`,assignProduct)
  }

  isProductTemplateUsed(id?: string,productId?: string, formId?: string): Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiProduct}/isTemplateUsed/${formId}?id=${id}&productId=${productId}`)
  }

  getProductsByProductFormId(productFormId: string): Observable<any> {
    return this.baseDataService.makeGetCall(`${this.apiProduct}/GetProductByProductFormId/${productFormId}`)
  }

  getUnUsedProductsByProductFormId(productFormId: string): Observable<any> {
    return this.baseDataService.makeGetCall(`${this.apiProduct}/un-used?formId=${productFormId}`)
  }
}
